import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { getShop, type MasterDataShopResponse } from '@generated/search-bff';

/**
 * Fetch shop details by master data id or short id using the `/api/v1/masterdata/shop/{idOrShortId}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/shop/getShopById Search API Documentation}
 */
export async function getShopById(idOrShortId: string, apiConfig: ApiConfig): Promise<ApiResult<MasterDataShopResponse>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'getShop');

  try {
    const shop = await getShop(idOrShortId, _apiConfig);

    return {
      status: 'success',
      data: shop,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
